import UserCompanyRoleList from './user-list';
export default function UserNav() {
  return (
    <div>
      <UserCompanyRoleList />
    </div>
  );
}
